import _toConsumableArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { clsx, cssVar } from "../../core/index.js";
import { defaultCaptionsProps } from "./Captions.js";
import { cssPrefix } from "./utils.js";
export var Description = function Description(_ref) {
  var _style;

  var description = _ref.description,
      descriptionTextAlign = _ref.descriptionTextAlign,
      descriptionMaxLines = _ref.descriptionMaxLines,
      styles = _ref.styles;
  return React.createElement("div", {
    style: styles.captionsDescriptionContainer,
    className: clsx(cssPrefix("captions_container"), cssPrefix("description_container"))
  }, React.createElement("div", {
    className: cssPrefix("description"),
    style: _objectSpread(_objectSpread({}, descriptionTextAlign !== defaultCaptionsProps.descriptionTextAlign || descriptionMaxLines !== defaultCaptionsProps.descriptionMaxLines ? {
      style: (_style = {}, _defineProperty(_style, cssVar("slide_description_text_align"), descriptionTextAlign), _defineProperty(_style, cssVar("slide_description_max_lines"), descriptionMaxLines), _style)
    } : null), styles.captionsDescription)
  }, typeof description === "string" ? description.split("\n").flatMap(function (line, index) {
    return [].concat(_toConsumableArray(index > 0 ? [React.createElement("br", {
      key: index
    })] : []), [line]);
  }) : description));
};